import { AppUtil } from 'kuaidong-lib'
import { IAiTeacherConfig, IAiTeacherInfo } from 'kuaidong-model'

export function getAiTeacherConfig(): Promise<IAiTeacherConfig | null> {
  return AppUtil.httpGET('/ai_teacher/config', {})
}

export function addAiTeacher(name: string, image_id: string) {
  return AppUtil.httpPOST('/ai_teacher/save', {
    name,
    image_id,
  })
}

export function getAiTeacherInfo(): Promise<IAiTeacherInfo | null> {
  return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/ai_teacher/info`, {})
}

export function switchAiTeacher(is_open: boolean): Promise<any> {
  return AppUtil.httpPOST(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/ai_teacher/switch`, {
    is_open,
  })
}
